import { Box } from '@mui/material'

export const BackgroundDecoration = ({
  tripleBottomDecoration,
  opacity = 0.05,
  withTopDecoration,
}: {
  tripleBottomDecoration?: boolean
  opacity?: number
  withTopDecoration?: boolean
}) => {
  const commonStyles = {
    content: "''",
    position: 'absolute',
    backgroundColor: 'primary.main',
    opacity,
  }

  return (
    <>
      {withTopDecoration && (
        <Box top={0} left={0} position="fixed">
          <Box
            sx={{
              position: 'relative',

              '&::after': {
                ...commonStyles,
                height: '80px',
                width: '168px',
                clipPath: 'polygon(0 0, 100% 0, 0 100%)',
              },
            }}
          />

          <Box
            sx={{
              position: 'relative',
              '&::after': {
                ...commonStyles,
                height: '156px',
                width: '236px',
                clipPath: 'polygon(0 0, 100% 0, 0 100%)',
              },
            }}
          />
        </Box>
      )}

      <Box bottom={0} right={0} position="fixed">
        <Box
          sx={{
            position: 'relative',

            '&::after': {
              ...commonStyles,
              height: '100px',
              width: '200px',
              clipPath: 'polygon(0 100%, 100% 0, 100% 100%)',
              transform: 'translate(-100%, -100%)',
            },
          }}
        />

        <Box
          sx={{
            position: 'relative',

            '&::after': {
              ...commonStyles,
              height: '270px',
              width: '370px',
              clipPath: 'polygon(0 100%, 100% 0, 100% 100%)',
              transform: 'translate(-100%, -100%)',
            },
          }}
        />

        {tripleBottomDecoration && (
          <Box
            sx={{
              position: 'relative',

              '&::after': {
                ...commonStyles,
                height: '440px',
                width: '534px',
                clipPath: 'polygon(0 100%, 100% 0, 100% 100%)',
                transform: 'translate(-100%, -100%)',
              },
            }}
          />
        )}
      </Box>
    </>
  )
}
